<template>
  <div class="index-paymentDetail">
    <comTop></comTop>
    
    <el-dialog
      title="转账账户"
      :visible.sync="dialogAcount"
      :modal="false"
      width="50%"
      :before-close="handleClose"
    >
      <el-form :model="form" class="form_acount" ref="ruleForm">
        <el-form-item label="趣花分期还至账户 : " :label-width="formLabelWidth" v-if="aliAcountArr.length">
          <el-input v-for="item in aliAcountArr" :key="item" :value="item.key + (item.value ?  ' / ' + item.value : '')" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="还呗还至账户 : " :label-width="formLabelWidth" v-if="huanAcountArr.length">
          <el-input
            v-for="item in huanAcountArr"
            :key="item + Math.floor(Math.random() * 10 + 1)"
            :value="item.key + (item.value ?  ' / ' + item.value : '')"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <span class="paymentDetail_acount">
          还款时请备注 ：姓名，手机号或者身份证号后六位
          <br />
          尊敬用户[{{paramsData && paramsData.user ? paramsData.user.name : '暂无'}}]请还款至相对应的账户哦！！！
        </span>
      </el-form>
    </el-dialog>

    <el-dialog
      class="dialogClears"
      :visible.sync="dialogClears"
      :modal="false"
      width="40%"
      :before-close="handleClose"
    >
      <el-carousel height="150px">
          <el-carousel-item v-for="item in viewerArr ? viewerArr : []" :key="item">
            <viewer :images="viewerArr">
              <img class="imgClears" :src="item">
            </viewer>
          </el-carousel-item>
      </el-carousel>
    </el-dialog>

    <el-dialog
      class="dialogClears"
      :visible.sync="singleClears"
      :modal="false"
      width="40%"
      :before-close="handleClose"
    >
      <el-carousel height="150px">
        <viewer :images="[pictureUrlNew]">
          <img class="imgClears" :src="pictureUrlNew" alt="图片">
        </viewer>
      </el-carousel>
    </el-dialog>

    <el-dialog
      title=" "
      :visible.sync="dialogOver"
      :modal="false"
      width="95%"
      :before-close="handleClose"
    >
      <div style="font-size: 14px;">
        &nbsp;&nbsp;&nbsp;&nbsp;尊敬的{{debtOverName}}:<br /><br />&nbsp;&nbsp;&nbsp;&nbsp;由于您于{{debtDate}}申请金额为{{debtCapital}}元的借款长期逾期未结清，原债权人{{debtOverData.lenders}}已于{{debtOverData.receiptTime}}将对您享有的债权转让给{{debtOverData.receiptBody}}。现{{debtOverData.productName}}已关闭您的还款功能。<br /><br />&nbsp;&nbsp;&nbsp;&nbsp;如有疑问可咨询官方客服：<b>400-800-1271</b>；或关注微信公众号：<b>「扬海资产」</b>
      </div>
    </el-dialog>

    <el-dialog
      title=" "
      :visible.sync="dialogFindPayInfo"
      :modal="false"
      width="95%"
      :before-close="handleClose"
    >
      <h2 :style="{ color: 'red'}">
        因财务入账需要时间，若您已还款，请于3个工作日后查看还款记录。如遇长时间未入账，请及时拨打客服热线：4008001271，或在本公众号对话框内联系在线客服（周一至周六，早9点-17点）。<br>
      </h2>
      <br>
      <el-table
        size="mini"
        :data="tableInfoList"
        ref="buyerTable"
        style="width: 100%"
        class="pub-table"
        header-row-class-name="pub-table-header-row"
        header-cell-class-name="pub-table-header-cell"
        @selection-change="selectionChange"
        :row-key="getRowKeys"
      >
        <el-table-column prop="repayTime" label="还款时间" min-width="80" ></el-table-column>
        <el-table-column prop="repayAmount" label="还款金额" min-width="60"></el-table-column>
        <el-table-column prop="paymentAccount" label="收款账户" min-width="80"></el-table-column>
      </el-table>
    </el-dialog>

    <!-- 合同编号明细弹窗 -->
    <el-dialog
      title=""
      :visible.sync="dialogContractDetail"
      :modal="false"
      width="50%"
      :before-close="handleClose"
    >
      <div class="contract-detail-content">
        <div class="contract-detail-label">结清合同编号：</div>
        <div class="contract-detail-text">{{ contractDetailText }}</div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogContractDetail = false">关 闭</el-button>
      </span>
    </el-dialog>

    <!-- 生成结清证明的弹窗 -->
    <el-dialog
      :visible.sync="dialogVisibleImg"
      width="60%"
      :max-width="800"
      :show-close="false"
      :before-close="handleClose"
      class="dialogClearsNew"
      :close-on-click-modal="true"
      :modal="false"
      :lock-scroll="false"
    >
      <!-- 重构后的证明容器 -->
      <div class="certificate-container" ref="imageDom">
        <!-- 背景容器 -->
        <div class="certificate-wrapper">
          <!-- 高清背景图片 -->
          <img class="certificate-bg" src="./../../assets/img/clear.jpg" alt="背景" />
          
          <!-- 证明内容容器 -->
          <div class="certificate-content">
            <h3 class="certificate-title">结清证明</h3>
            
            <!-- 正文内容区 - 修复重复显示合同编号的问题 -->
            <div class="certificate-body">
              <template v-if="clearanceObj">
                <p class="certificate-paragraph">
                  债务人{{ clearanceObj.name }}（身份证号：{{ clearanceObj.carId }}）在{{ clearanceObj.lenders }}旗下的{{ clearanceObj.productName }}平台借款，
                  <template v-if="isFuLongDai(clearanceObj.productName)">
                    <!-- 富龙贷：显示带省略的合同编号（已包含完整前缀） -->
                    <span v-html="getFormattedPactId(clearanceObj)"></span>
                  </template>
                  <template v-else>
                    <!-- 其他产品：保持原逻辑 -->
                    合同编号：{{ clearanceObj.pactId }}
                  </template>
                  。
                  <template v-if="clearanceObj.receiptTime">
                    原债权人{{ clearanceObj.lenders }}于 {{ clearanceObj.receiptTime }} 将对您享有的债权转让给{{ clearanceObj.receiptBody }}，
                  </template>
                  <template v-if="clearanceObj.repayLastTime">
                    截止 {{ clearanceObj.repayLastTime }} 您的该笔债务已结清。
                  </template>
                </p>
                
                <p class="certificate-paragraph" v-if="clearanceObj.type == 1 || clearanceObj.type == 2 || clearanceObj.type == 4">
                  请您保留好还款流水（或存款证明），此证明与还款流水（或存款证明）结合使用时才具有法律效力，若您未实际还款，此证明不生效。
                </p>
                
                <p class="certificate-paragraph">特此证明。</p>
              </template>
            </div>
            
            <!-- 签名区域 -->
            <div class="certificate-signature">
              <div class="signature-content">
                <p class="signature-company">{{ clearanceObj.receiptBody }}</p>
                <p class="signature-date">{{ clearanceObj.nowTime }}</p>
              </div>
              
              <!-- 高清印章图片 - 只在生成前显示 -->
              <img
                v-if="!generatedImageUrl"
                class="signature-seal"
                src="./../../assets/img/zhang.gif"
                alt="印章"
                ref="sealImage"
              />
            </div>
          </div>
        </div>
        
        <!-- 生成的图片 - 完全覆盖在背景上 -->
        <div v-if="generatedImageUrl" class="generated-image-overlay">
          <img 
            :src="generatedImageUrl" 
            alt="结清证明" 
            class="generated-image"
            @click="closeCertificateDialog"
          />
          <div class="image-tips">长按图片进行保存下载</div>
          <!-- 新增的提示信息和复制按钮 -->
          <div class="clarity-prompt">
            <p class="clarity-text">结清证明如果不清晰,请点击下方按钮复制链接去外部浏览器访问</p>
            <div class="copy-btn-container">
              <el-button 
                type="primary" 
                size="small" 
                class="copy-btn"
                @click="copyCertificateLink"
              >
                复制查询链接
              </el-button>
            </div>
            <!-- 生成后的合同编号明细按钮（仅富龙贷显示） -->
            <div v-if="clearanceObj && isFuLongDai(clearanceObj.productName)" class="contract-detail-btn-container">
              <el-button 
                type="success" 
                size="small" 
                class="contract-detail-btn"
                @click="showContractDetail(clearanceObj)"
              >
                合同编号明细
              </el-button>
            </div>
          </div>
        </div>
      </div>
      
      <div slot="footer" class="dialog-footer">
        <!-- 富龙贷产品：在生成按钮旁边添加合同编号明细按钮 -->
        <template v-if="!generatedImageUrl && !isGenerating && clearanceObj && isFuLongDai(clearanceObj.productName)">
          <el-button type="primary" @click="handleGenerateCertificate">确定生成证明</el-button>
          <el-button type="success" @click="showContractDetail(clearanceObj)">合同编号明细</el-button>
        </template>
        <template v-else-if="!generatedImageUrl && !isGenerating">
          <el-button type="primary" @click="handleGenerateCertificate">确定生成证明</el-button>
        </template>
        <el-button v-if="!generatedImageUrl && isGenerating" type="primary" :loading="true">正在生成中...</el-button>
      </div>
    </el-dialog>

    <!-- 查看已生成结清证明的弹窗（只显示图片，没有背景模板） -->
    <el-dialog
      :visible.sync="dialogViewGenerated"
      width="60%"
      :max-width="800"
      :show-close="true"
      :before-close="handleClose"
      class="dialogViewGenerated"
      :close-on-click-modal="true"
      :modal="false"
      :lock-scroll="false"
    >
      <div class="view-generated-container">
        <img 
          :src="viewGeneratedUrl" 
          alt="结清证明" 
          class="view-generated-image"
        />
        <div class="view-generated-tips">长按图片进行保存下载</div>
        <!-- 在查看已生成证明弹窗中也添加提示 -->
        <div class="clarity-prompt">
          <p class="clarity-text">结清证明如果不清晰,请点击下方按钮复制链接去外部浏览器访问</p>
          <div class="copy-btn-container">
            <el-button 
              type="primary" 
              size="small" 
              class="copy-btn"
              @click="copyCertificateLink"
            >
              复制查询链接
            </el-button>
          </div>
          <!-- 查看已有证明时的合同编号明细按钮（仅富龙贷显示） -->
          <div v-if="viewClearanceObj && isFuLongDai(viewClearanceObj.productName)" class="contract-detail-btn-container">
            <el-button 
              type="success" 
              size="small" 
              class="contract-detail-btn"
              @click="showContractDetail(viewClearanceObj)"
            >
              合同编号明细
            </el-button>
          </div>
        </div>
      </div>
      
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeViewGenerated">关闭</el-button>
      </div>
    </el-dialog>

    <!-- 浏览器提示弹窗 -->
    <el-dialog
      :visible.sync="dialogBrowserPrompt"
      title="提示"
      width="80%"
      :modal="false"
      :show-close="false"
      :close-on-click-modal="false"
      :before-close="handleClose"
    >
      <div style="text-align: center;">
        <h3 style="color: #E6A23C; margin-bottom: 15px;">生成证明较慢</h3>
        <p style="margin-bottom: 10px;">生成结清证明需要较长时间，建议您复制以下链接，在手机浏览器中打开：</p>
        <div style="background: #f5f5f5; padding: 10px; border-radius: 4px; word-break: break-all; margin: 15px 0; position: relative;">
          <b id="copyLinkText">https://www.hzyhamc.com/#/settlementCertificate</b>
        </div>
        <p style="color: #F56C6C; font-size: 12px;">复制后，请粘贴到手机浏览器地址栏中打开</p>
      </div>
      
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取消</el-button>
        <el-button type="primary" @click="copyLink">复制链接</el-button>
      </span>
    </el-dialog>

    <el-row class="paymentDetail_top">
      <div class="paymentDetail_img"><img src="./../../assets/img/111.jpg" alt=""></div>
      
      <el-col :span="1">&nbsp;</el-col>
      <el-col :span="22">
        <div class="paymentDetail_box">
          <el-row class="paymentDetail_box_top">
            <el-col :span="16">
              <h3 class="p1">{{paramsData.user ? paramsData.user.name : '暂无'}}</h3>
              <span>手机号码：{{paramsData.user ? desensitizePhone(paramsData.user.phone): '暂无'}}</span>&nbsp;&nbsp;&nbsp;&nbsp;
              <span style="display: inline-block; margin-bottom: 14px;">证件号码：{{paramsData.user ? desensitizeID(paramsData.user.carId): '暂无'}}</span>
            </el-col>
            <el-col :span="8" v-if="totalMoney != 0">
              <p class="p2">结清应还款金额</p>
              <h3 class="p3">￥{{XHJNum === 0 && paramsData.lists[0].caseBatch === 'XHJ' ? XHJNum : totalMoney}}</h3>
            </el-col>
            <el-col :span="8" v-else>
              <el-tag class="paymentDetail_clear" v-if="showTagClear" size="medium" type="success">已结清</el-tag>
              <el-tag class="paymentDetail_clear" v-if="showTagNoClear" size="medium" type="success">部分结清</el-tag>
            </el-col>
          </el-row>

          <div
            class="paymentDetail_box_div"
            v-for="item in paramsData.lists ? paramsData.lists : []"
            :key="item.debtMoney + Math.floor(Math.random() * 1000 + 1)"
          >
            <el-row class="paymentDetail_box_con">
              <el-col :span="18">
                <h2>{{item.productName}} <span @click="debtOver(item)" >债权说明</span><span @click="findPayInfo(item)" >还款记录</span><span v-if="(item.debtMoney == 0 || item.debtMoney === '0') && item.productName !== '享换机'" @click="findClear(item)" class="clear-certificate">结清证明</span></h2>
                <span>{{item.lenders}}</span>
              </el-col>
              <el-col :span="6">
                <h2>&nbsp;</h2>
                <p>借款时间 : {{ item.borrowTime }}</p>
              </el-col>
            </el-row>
            <div class="border"></div>
            <el-row v-if="item.debtMoney != 0" class="paymentDetail_box_bom">
              <el-col :span="6">
                <h4>借款金额</h4>
                <span>{{item.leftCapital}}</span>
              </el-col>
              <el-col :span="6">
                <h4>逾期天数</h4>
                <span class="overdueDays">{{item.overdueDays}}</span>
              </el-col>
              <el-col :span="6">
                <h4>原逾期应还总金额</h4>
                <span>{{parseFloat(item.debtMoney) < 0 ? '0' : item.overdueMoney}}</span>
              </el-col>
            </el-row>
          </div>
        </div>
        <div v-if="!paramsData.list.length">
          <h5>选择支付方式</h5>
          <p>温馨提示：受银行处理时间影响，采用线下汇款方式到账会有延迟；强烈建议采用支付宝即时到账</p>
        </div>
        <el-row class="paymentDetail_btn" v-if="!paramsData.list.length">
          <el-col>
            <el-button type="primary" icon="el-icon-vue-zhifubao" @click="aliAcount(1)">支付宝对公账户支付</el-button>
            <span class="paymentDetail_tj">推荐</span>
            <el-button type="primary" icon="el-icon-vue-weibiaoti-" @click="aliAcount(2)">线下对公账户转账</el-button>
          </el-col>
        </el-row>
      </el-col>
      <el-col :span="1"></el-col>
    </el-row>
    <comFooter></comFooter>
  </div>
</template>

<script>
import comTop from "@/components/page/comTop.vue"; //头部
import comFooter from "@/components/page/comFooter.vue"; //脚部
import "./../../../static/icon/iconfont";
import html2canvas from "html2canvas";

export default {
  components: {
    comFooter,
    comTop
  },
  data() {
    return {
      paramsData: this.$route.params.data,
      totalMoney: 0,
      dialogAcount: false,
      dialogClears: false,
      singleClears: false,
      pictureUrlNew: '',
      totalArr: [],
      listSelection: [],
      clearanceObj: {},
      dialogVisibleImg: false,
      dialogOver: false,
      dialogFindPayInfo: false,
      form: {},
      formLabelWidth: "120px",
      aliAcountArr: [],
      huanAcountArr: [],
      viewerArr : [],
      debtOverData : {},
      debtOverName : '',
      debtDate : '',
      debtCapital :'',
      XHJNum: 0,
      isXHJ: false,
      tableInfoList:[],
      showTagClear: false,
      showTagNoClear: false,
      
      // 新增的状态
      isGenerating: false, // 是否正在生成证明
      generatedImageUrl: null, // 生成的图片URL（从服务器返回）
      
      // 查看已生成证明的状态
      dialogViewGenerated: false,
      viewGeneratedUrl: '',
      viewClearanceObj: {}, // 存储已查看的结清证明对象，用于显示合同明细
      
      // 浏览器提示弹窗
      dialogBrowserPrompt: false,
      
      // 超时相关
      timeoutId: null,
      // 修改：添加一个标记，记录是否已经点击了生成按钮
      hasClickedGenerate: false,
      
      // 合同编号明细弹窗
      dialogContractDetail: false,
      contractDetailText: '',
    };
  },
  computed: {},
  watch: {
    '$route' () {
      console.info("!11111111")
    }
  },
  methods: {
    // 判断是否为富龙贷产品
    isFuLongDai(productName) {
      return productName === '富龙贷';
    },
    
    // 获取格式化的合同编号HTML内容（用于v-html）- 修复：只返回带省略的合同编号文本，不重复添加前缀
    getFormattedPactId(clearanceObj) {
      if (!clearanceObj || !clearanceObj.pactId) return '';
      // 只有富龙贷产品才进行省略处理
      if (!this.isFuLongDai(clearanceObj.productName)) {
        return `合同编号：${clearanceObj.pactId}`;
      }
      const pactIdCount = clearanceObj.pactIdCount || 0;
      const pactIdStr = clearanceObj.pactId;
      
      if (pactIdCount <= 1) {
        return `合同编号：${pactIdStr}`;
      }
      
      const pactIds = pactIdStr.split(',');
      if (pactIds.length <= 1) {
        return `合同编号：${pactIdStr}`;
      }
      
      // 显示第一个和最后一个，中间用......省略
      const firstId = pactIds[0];
      const lastId = pactIds[pactIds.length - 1];
      // 返回带完整前缀的字符串
      return `合同编号(共${pactIdCount}笔)：${firstId},  ......,  ${lastId}`;
    },
    
    // 显示合同编号明细弹窗
    showContractDetail(clearanceObj) {
      if (!clearanceObj || !clearanceObj.pactId) {
        this.$message.warning('暂无合同编号信息');
        return;
      }
      
      const pactIdCount = clearanceObj.pactIdCount || 0;
      const pactIdStr = clearanceObj.pactId;
      
      if (pactIdCount > 1 && pactIdStr.includes(',')) {
        // 多个合同编号，完整显示
        this.contractDetailText = pactIdStr;
      } else {
        // 单个合同编号
        this.contractDetailText = pactIdStr;
      }
      
      this.dialogContractDetail = true;
    },
    
    handleClose() {
      let that = this;
      that.dialogAcount = false;
      that.dialogClears = false;
      that.singleClears = false;
      that.dialogVisibleImg = false;
      that.dialogOver = false;
      that.dialogFindPayInfo = false;
      that.isGenerating = false;
      that.generatedImageUrl = null;
      that.dialogViewGenerated = false;
      that.viewGeneratedUrl = '';
      that.dialogBrowserPrompt = false;
      that.hasClickedGenerate = false; // 重置标记
      that.dialogContractDetail = false;
      that.contractDetailText = '';
      that.viewClearanceObj = {};
      
      // 清除超时定时器
      if (that.timeoutId) {
        clearTimeout(that.timeoutId);
        that.timeoutId = null;
      }
    },
    
    closeCertificateDialog() {
      this.dialogVisibleImg = false;
      this.generatedImageUrl = null;
      this.isGenerating = false;
      this.hasClickedGenerate = false;
    },
    
    closeViewGenerated() {
      this.dialogViewGenerated = false;
      this.viewGeneratedUrl = '';
      this.viewClearanceObj = {};
    },
    
    // 复制结清证明链接
    copyCertificateLink() {

      let that = this;

      const textToCopy = 'https://www.hzyhamc.com/#/settlementCertificate';
      
      // 创建临时输入框
      const tempInput = document.createElement('input');
      tempInput.value = textToCopy;
      document.body.appendChild(tempInput);
      
      // 选中文本
      tempInput.select();
      tempInput.setSelectionRange(0, 99999); // 移动端兼容
      
      try {
        // 执行复制
        const successful = document.execCommand('copy');
        if (successful) {

      that.delClearAfterCopy();

          this.$message({
            message: '查询链接已复制到剪贴板！',
            type: 'success',
            duration: 2000
          });



        } else {
          this.$message({
            message: '复制失败，请手动复制链接',
            type: 'warning',
            duration: 3000
          });
        }
      } catch (err) {
        console.error('复制失败:', err);
        this.$message({
          message: '复制失败，请手动复制链接',
          type: 'error',
          duration: 3000
        });
      }
      
      // 移除临时输入框
      document.body.removeChild(tempInput);
    },
    // 新增：复制成功后调用的删除方法
delClearAfterCopy() {
  let that = this;
  // 获取 carId 和 productName
  let carId = '';
  let productName = '';
  
  // 从 clearanceObj 中获取数据
  if (that.clearanceObj && that.clearanceObj.carId) {
    carId = that.clearanceObj.carId;
    productName = that.clearanceObj.productName || '';
  } 
  // 如果 clearanceObj 不存在，尝试从 paramsData 中获取
  else if (that.paramsData && that.paramsData.user && that.paramsData.user.carId) {
    carId = that.paramsData.user.carId;
    // 如果有多个产品，取第一个
    if (that.paramsData.lists && that.paramsData.lists.length > 0) {
      productName = that.paramsData.lists[0].productName || '';
    }
  }
  
  // 如果没有获取到必要参数，只提示但不中断
  if (!carId) {
    console.warn('无法获取用户信息，删除操作跳过');
    return;
  }
  
  // 调用 delClear 接口
  that.ajaxJson({
    url: "/website/delClear",
    method: "POST", // 根据实际接口调整请求方法
    data: {
      carId: carId,
      productName: productName
    },
    success: function(data) {
      if (data.code == "0000") {
        // 可选：静默成功，不提示用户
        console.log('删除成功');
      } else {
        console.warn('删除失败:', data.message);
      }
    },
    error: function(error) {
      console.error('调用 delClear 接口失败:', error);
    }
  });
},
    formatter_timeYM(value) {
      if (!value) return ''
      const date = new Date(value)
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      return `${year}-${month}`
    },
    desensitizePhone(phone) {
      if (!phone) return '';
      return phone.replace(/(\d{3})\d{4}(\d{4})/, '$1****$2');
    },
    desensitizeID(id) {
      if (!id) return '';
      return id.replace(/(\d{3})\d{8}(\d{3})/, '$1**********$2');
    },
    debtOver(item) {
      let that = this;
      that.dialogOver = true;
      that.ajaxJson({
        url: "/website/getSysInfo?caseBatch=" + item.caseBatch,
        method: "GET",
        success: function(data) {
          if (data.code == "0000") {
            that.debtOverName = item.name
            that.debtCapital = item.leftCapital
            that.debtDate = item.borrowTime
            that.debtOverData = data.data
          }
        }
      });
    },
    findPayInfo(item) {
      let that = this;
      that.dialogFindPayInfo = true;
      that.ajaxJson({
        url: "/website/findPayInfo?caseBatch=" + item.caseBatch +"&carId=" + item.carId,
        method: "GET",
        success: function(data) {
          if (data.code == "0000") {
            that.tableInfoList = data.data;
          }
        }
      });
    },
    findClear(item) {
      let that = this;
      
      // 存在结清证明则直接打开图片
      if (item.contractUrl != null && item.contractUrl != '') {
        // 存储结清证明对象，用于显示合同明细
        that.viewClearanceObj = {
          pactId: item.pactId,
          pactIdCount: item.pactIdCount,
          productName: item.productName,
          name: item.name,
          carId: item.carId,
          lenders: item.lenders,
          receiptTime: item.receiptTime,
          repayLastTime: item.repayLastTime,
          receiptBody: item.receiptBody,
          nowTime: item.nowTime,
          type: item.type
        };
        // 使用单独的查看弹窗，只显示图片本身
        that.viewGeneratedUrl = item.contractUrl;
        that.dialogViewGenerated = true;
      } else {
        // 不存在结清证明，走生成流程
        that.clearance(item.id);
      }
    },
    
    // 修改：添加生成证明的包装方法
    handleGenerateCertificate() {
      let that = this;
      
      // 清除之前的超时定时器
      if (that.timeoutId) {
        clearTimeout(that.timeoutId);
        that.timeoutId = null;
      }
      
      // 标记已经点击了生成按钮
      that.hasClickedGenerate = true;
      
      // 设置超时检测（5秒，给更长时间）
      that.timeoutId = setTimeout(() => {
        // 5秒后如果还在生成中且还没有生成图片，显示浏览器提示
        if (that.isGenerating && !that.generatedImageUrl) {
          // 停止生成状态
          that.isGenerating = false;
          // 显示提示弹窗
          that.dialogBrowserPrompt = true;
        }
      }, 5000); // 改为5秒，给更宽松的时间
      
      // 开始生成证明
      that.generateCertificate();
    },
    
    // 复制链接到剪贴板
    copyLink() {
      const textToCopy = 'https://www.hzyhamc.com/#/settlementCertificate';
      
      // 创建临时输入框
      const tempInput = document.createElement('input');
      tempInput.value = textToCopy;
      document.body.appendChild(tempInput);
      
      // 选中文本
      tempInput.select();
      tempInput.setSelectionRange(0, 99999); // 移动端兼容
      
      try {
        // 执行复制
        const successful = document.execCommand('copy');
        if (successful) {
          this.$message({
            message: '链接已复制到剪贴板！',
            type: 'success',
            duration: 2000
          });
          // 复制成功后关闭弹窗
          this.handleClose();
        } else {
          this.$message({
            message: '复制失败，请手动复制链接',
            type: 'warning',
            duration: 3000
          });
        }
      } catch (err) {
        console.error('复制失败:', err);
        this.$message({
          message: '复制失败，请手动复制链接',
          type: 'error',
          duration: 3000
        });
      }
      
      // 移除临时输入框
      document.body.removeChild(tempInput);
    },
    
    clearance(caseId) {
      let that = this;
      that.totalArr = [];
      that.ajaxJson({
        url: "/collection/clearance?caseId=" + caseId,
        method: "GET",
        success: function(data) {
          if (data.code == "0000") {
            that.clearanceObj = data.data;
            that.totalArr.push(that.clearanceObj);
            
            // 重置状态
            that.generatedImageUrl = null;
            that.isGenerating = false;
            that.hasClickedGenerate = false;
            
            // 打开生成证明的弹窗（包含背景模板和印章）
            that.dialogVisibleImg = true;
          }
        }
      });
    },
    
    async generateCertificate() {
      let that = this;
      that.isGenerating = true;
      
      try {
        // 1. 预加载印章图片，确保图片加载完成
        await new Promise((resolve) => {
          if (that.$refs.sealImage && that.$refs.sealImage.complete) {
            resolve();
          } else if (that.$refs.sealImage) {
            that.$refs.sealImage.onload = resolve;
            that.$refs.sealImage.onerror = resolve;
          } else {
            resolve();
          }
        });
        
        // 2. 获取容器尺寸
        const container = that.$refs.imageDom;
        const width = container.offsetWidth;
        const height = container.offsetHeight;
        
        // 3. 使用html2canvas生成高清图片
        const canvas = await html2canvas(container, {
          scale: 3, // 提高3倍分辨率
          useCORS: true,
          allowTaint: true,
          backgroundColor: '#ffffff',
          width: width,
          height: height,
          logging: false, // 关闭日志
          imageTimeout: 0, // 不超时
          removeContainer: true,
          
          // 高质量配置
          onclone: function(clonedDoc) {
            // 克隆时确保样式正确
            const clonedContainer = clonedDoc.querySelector('.certificate-container');
            if (clonedContainer) {
              clonedContainer.style.width = width + 'px';
              clonedContainer.style.height = height + 'px';
            }
          }
        });
        
        // 4. 创建更高清的canvas（如果需要）
        const finalCanvas = document.createElement('canvas');
        finalCanvas.width = width * 3; // 3倍分辨率
        finalCanvas.height = height * 3;
        const ctx = finalCanvas.getContext('2d');
        
        // 5. 设置高质量绘制
        ctx.imageSmoothingEnabled = true;
        ctx.imageSmoothingQuality = 'high';
        ctx.drawImage(canvas, 0, 0, finalCanvas.width, finalCanvas.height);
        
        // 6. 获取高质量base64数据
        const base64Data = finalCanvas.toDataURL("image/png", 1.0); // 使用PNG格式，最高质量
        
        // 7. 上传到服务器
        if (that.totalArr && that.totalArr.length > 0) {
          for (let item of that.totalArr) {
            const addX = {
              name: item.name,
              carId: item.carId,
              picture: base64Data,
              clearMoney: item.debtMoney,
              productName: item.productOldName,
              imageType: 'base64'
            };
            
            await new Promise((resolve, reject) => {
              that.ajaxJson({
                url: "/website/addClear",
                data: addX,
                success: function(data) {
                  if (data.code == "0000") {
                    // 使用高质量PNG base64数据
                    that.generatedImageUrl = base64Data;
                    that.showMsg("高清结清证明生成成功!", "success");
                    
                    // 清除超时定时器，防止提示弹出
                    if (that.timeoutId) {
                      clearTimeout(that.timeoutId);
                      that.timeoutId = null;
                    }
                    
                    resolve();
                  } else {
                    reject(new Error(data.message || '生成失败'));
                  }
                },
                error: function(error) {
                  reject(error);
                }
              });
            });
          }
        }
      } catch (error) {
        console.error('生成证明失败:', error);
        that.showMsg("生成结清证明失败，请重试", "error");
        
        // 清除超时定时器
        if (that.timeoutId) {
          clearTimeout(that.timeoutId);
          that.timeoutId = null;
        }
        
        throw error;
      } finally {
        that.isGenerating = false;
      }
    },
    
    clears() {
      let that = this;
      that.dialogClears = true;
    },
    aliAcount(int) {
      let that = this;
      let batch = "";
      that.dialogAcount = true;
      that.aliAcountArr = [];
      that.huanAcountArr = [];
      that.paramsData.lists && that.paramsData.lists.length == 1
        ? (batch = that.paramsData.lists[0].caseBatch)
        : (batch = "");
      that.ajaxJson({
        url:
          "/website/getAccount?id=" +
          int +
          (batch ? "&caseBatch=" + batch : ""),
        method: "GET",
        success: function(data) {
          if (data.code == "0000") {
            data.data &&
              data.data.map(item => {
                if (item.caseBatch == "QHFQY") {
                  let obj = {};
                  obj = {
                    key : item.account,
                    value : item.openingBank
                  }
                  that.aliAcountArr.push(obj);
                }
                if (item.caseBatch == "SHSHY") {
                  let obj = {};
                  obj = {
                    key : item.account,
                    value : item.openingBank
                  }
                  that.huanAcountArr.push(obj);
                }
              });
          }
        }
      });
      console.info(that.aliAcountArr, that.huanAcountArr);
    }
  },
  created() {
    let that = this;
    this.paramsData == undefined
      ? this.$router.push({ path: "/index" })
      : this.paramsData;
    this.paramsData.lists &&
      this.paramsData.lists.map(item => {
        this.XHJNum += parseFloat(item.debtMoney);
        this.totalMoney += parseFloat(item.debtMoney == '0' ? 0 : item.overdueMoneys);
        this.totalMoney = parseFloat(this.totalMoney.toFixed(2));
      });
    if(this.XHJNum == 0){
      this.showTagClear = true;
    }else{
      this.showTagNoClear = true;
    }
    this.paramsData.list && this.paramsData.list.map(item => {
      console.info("----11111111111111111111------------"+ item.pictureUrl);
      that.viewerArr.push(item.pictureUrl);
    });
    console.info("----0000000000000000000000000------------"+ this.viewerArr);
  },
  beforeDestroy() {
    // 组件销毁前清除定时器
    if (this.timeoutId) {
      clearTimeout(this.timeoutId);
      this.timeoutId = null;
    }
  }
};
</script>

<style lang="less">
.clear_modal .el-dialog__header {
  padding: 0;
}
@import "//at.alicdn.com/t/font_1842670_t8gbuzq39xm.css";

/* 基础样式 */
@media screen and (min-width: 300px) and (max-width: 480px) {
  .componentRouter{
    height: 100%;
  }
  .index-paymentDetail{
    height: 100%;
  }
  .index-paymentDetail .paymentDetail_top{
    height: 100%;
  }
  .index-paymentDetail .introduceTop{
    display: none!important;
  }
  .index-paymentDetail .index-footer{
    display: none!important;
  }
  .paymentDetail_top .paymentDetail_img{
    display: block!important;
    width: 100%;
  }
  .paymentDetail_top .paymentDetail_img img{
    width: 100%;
    background-size: 100%;
  }
  .componentRouter .componentRouter_sett{
    display: block!important;
  }
}

.dialogClears .imgClears{
  width: 100%;
}
.componentRouter .componentRouter_sett{
  display: block!important;
}
.index-footer{
  display: block!important;
}
.paymentDetail_img{
  display: none;
}
.introduceTop{
  display: block!important;
}
[class^="el-icon-vue"],
[class^=" el-icon-vue"] {
  font-family: "iconfont", serif !important;
  font-style: normal;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.form_acount .el-form-item__content {
  margin-left: 125px;
}
.paymentDetail_acount {
  color: red;
}
.paymentDetail_clear {
  margin: 20px;
}
.paymentDetail_top {
  background: #ffffff;
  height: auto;
  min-height: 630px;
}
.paymentDetail_box_div {
  padding: 20px 0;
}
.paymentDetail_top .border {
  height: 1px;
  background: #eee;
  margin: 0px 20px;
  opacity: 0.5;
}
.paymentDetail_box_top {
  background: rgba(247, 247, 247, 1);
  border-radius: 10px 10px 0px 0px;
  padding: 0 30px;
}
.paymentDetail_box {
  border: 1px solid rgba(247, 247, 247, 1);
}
.paymentDetail_box_con h2 span{
  font-size: 10px;
  color: #287AFF;
  cursor: pointer;
  padding: 0 3px;
}
.paymentDetail_box_top .p1 {
  font-size: 30px;
  color: rgba(34, 34, 34, 1);
  margin: 10px 0;
}
.paymentDetail_box_top .p3 {
  color: red;
  font-size: 22px;
  font-weight: 600;
}
.paymentDetail_box_top span {
  font-size: 16px;
  color: rgba(34, 34, 34, 1);
}
.paymentDetail_box_con {
  padding: 0 1px;
}
.paymentDetail_box_bom {
  padding: 0 30px;
}
.paymentDetail_box_bom .overdueDays {
  font-size: 22px;
}
.paymentDetail_btn {
  padding: 40px 0;
}
.paymentDetail_btn .el-button {
  width: 340px;
  height: 100px;
  border-radius: 10px;
  border: 1px solid rgba(204, 204, 204, 1);
}
.paymentDetail_btn .el-button .el-icon-vue-zhifubao {
  position: relative;
  top: 0px;
  left: 0px;
  font-size: 60px;
}
.paymentDetail_btn .el-button .el-icon-vue-weibiaoti- {
  position: relative;
  top: 0px;
  left: 0px;
  font-size: 60px;
}
.paymentDetail_btn .el-button span {
  position: relative;
  top: -10px;
  font-size: 24px;
}
.paymentDetail_btn .paymentDetail_tj {
  width: 55px;
  height: 16px;
  background: rgba(255, 90, 90, 1);
  border-radius: 95px 0 49px 1px;
  position: absolute;
  top: 123px;
  left: 284px;
  text-align: center;
  line-height: 16px;
  color: #fff;
  font-size: 10px;
}

/* 结清证明新样式 - 核心修改部分 */
.dialogClearsNew.el-dialog {
  max-width: 800px;
  width: 90% !important;
  margin: 20px auto;
}

/* 证明容器 */
.certificate-container {
  position: relative;
  width: 100%;
  min-height: 600px;
  background: white; /* 确保背景为白色 */
}

/* 背景容器 */
.certificate-wrapper {
  position: relative;
  width: 100%;
  min-height: 600px;
}

/* 背景图片 - 确保清晰 */
.certificate-bg {
  width: 100%;
  height: auto;
  display: block;
  image-rendering: -webkit-optimize-contrast; /* 提高图片渲染质量 */
  image-rendering: crisp-edges;
}

/* 证明内容容器 */
.certificate-content {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  padding: 5% 8% 18% 8%;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

/* 证明标题 - 提高字体清晰度 */
.certificate-title {
  text-align: center;
  font-size: 100px;
  font-weight: bold;
  color: #333;
  margin-bottom: 0px;
  line-height: 1.8;
  text-shadow: 0.5px 0.5px 0.5px rgba(0,0,0,0.1); /* 轻微阴影提高清晰度 */
}

/* 正文内容区 - 提高字体清晰度 */
.certificate-body {
  flex: 1;
  font-size: 55px;
  line-height: 1.8;
  color: #333;
  text-shadow: 0.3px 0.3px 0.3px rgba(0,0,0,0.1);
}

/* 段落样式 */
.certificate-paragraph {
  margin-bottom: 15px;
  text-indent: 2em;
  text-align: justify;
}

/* 签名区域 */
.certificate-signature {
  position: relative;
  width: 100%;
  margin-top: -70px;
  padding-right: 0%;
  box-sizing: border-box;
}

/* 签名内容 */
.signature-content {
  text-align: right;
  line-height: 1;
}

.signature-company {
  font-size: 48px;
  font-weight: 600;
  margin-bottom: 5px;
  text-shadow: 0.3px 0.3px 0.3px rgba(0,0,0,0.1);
}

.signature-date {
  font-size: 48px;
  font-weight: 600;
  color: #666;
  text-shadow: 0.3px 0.3px 0.3px rgba(0,0,0,0.1);
}

/* 高清印章图片 - 关键修改：只在生成前显示 */
.signature-seal {
  position: absolute;
  width: 320px;
  height: 320px;
  right: 8%;
  bottom: 0;
  z-index: 1;
  opacity: 0.85; /* 稍微提高透明度让印章更清晰 */
  image-rendering: -webkit-optimize-contrast; /* 提高印章清晰度 */
  image-rendering: crisp-edges;
  filter: drop-shadow(0 0 1px rgba(0,0,0,0.2)); /* 轻微阴影提高辨识度 */
  
  /* 确保印章为高质量显示 */
  transform: translateZ(0); /* 硬件加速 */
  backface-visibility: hidden;
  -webkit-font-smoothing: antialiased;
}

/* 生成的图片覆盖层 */
.generated-image-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: white;
  z-index: 20;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  padding-top: 20px;
}

/* 生成的图片 - 高质量显示 */
.generated-image {
  width: 90% !important;
  max-height: calc(100% - 140px) !important;
  object-fit: contain; /* 改为contain确保完整显示 */
  display: block;
  cursor: pointer;
  image-rendering: -webkit-optimize-contrast;
  image-rendering: crisp-edges;
  margin: 0 auto;
}

/* 修改：长按图片保存下载提示改为红色 */
.image-tips {
  width: 100%;
  text-align: center;
  font-size: 14px;
  color: #F56C6C !important; /* 改为红色 */
  padding: 8px 0;
  z-index: 21;
  font-weight: 500;
  margin-top: 10px;
  margin-bottom: 10px;
}

/* 新增的清晰度提示区域 */
.clarity-prompt {
  width: 100%;
  text-align: center;
  padding: 10px 20px;
  box-sizing: border-box;
  margin-top: 10px;
}

.clarity-text {
  font-size: 14px;
  color: #d8260e;
  margin-bottom: 15px;
  font-weight: 500;
  line-height: 1.4;
  text-align: center;
}

/* 复制按钮容器 - 居中 */
.copy-btn-container {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  margin-bottom: 10px;
}

.copy-btn {
  min-width: 140px;
}

/* 合同编号明细按钮容器 */
.contract-detail-btn-container {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  margin-top: 10px;
}

.contract-detail-btn {
  min-width: 140px;
}

/* 合同编号明细弹窗样式 */
.contract-detail-content {
  padding: 10px;
  word-wrap: break-word;
  word-break: break-all;
  max-height: 400px;
  overflow-y: auto;
}

.contract-detail-label {
  font-weight: bold;
  margin-bottom: 10px;
  font-size: 16px;
  color: #333;
}

.contract-detail-text {
  font-size: 14px;
  line-height: 1.8;
  color: #555;
}

/* 查看已生成证明的样式 */
.dialogViewGenerated.el-dialog {
  max-width: 800px;
  width: 90% !important;
  margin: 20px auto;
}

.view-generated-container {
  position: relative;
  width: 100%;
  min-height: 500px;
  background: white;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  padding: 20px;
  box-sizing: border-box;
}

.view-generated-image {
  width: 90%;
  max-height: 350px;
  object-fit: contain;
  display: block;
  margin: 0 auto;
}

/* 修改：查看已生成证明的长按提示也改为红色 */
.view-generated-tips {
  margin-top: 15px;
  font-size: 14px;
  color: #F56C6C !important; /* 改为红色 */
  text-align: center;
  width: 100%;
  padding: 8px 0;
  font-weight: 500;
}

/* 浏览器提示弹窗样式 */
.dialogBrowserPrompt .el-dialog__body {
  padding: 20px !important;
}

.dialogBrowserPrompt .el-dialog__footer {
  padding: 10px 20px 20px !important;
}

/* 对话框底部按钮样式 */
.dialog-footer {
  display: flex;
  justify-content: center;
  gap: 20px;
  padding: 15px 20px 20px;
  margin-top: 20px;
}

.dialog-footer .el-button {
  min-width: 120px;
}

/* 移动端适配 */
@media screen and (max-width: 480px) {

/* 阻止微信字体调整影响结清证明 - 方案一 */
.dialogClearsNew *,
.dialogViewGenerated * {
  -webkit-text-size-adjust: none !important;
  -webkit-text-size-adjust: 100% !important;
  text-size-adjust: none !important;
}

  .dialogClearsNew.el-dialog,
  .dialogViewGenerated.el-dialog {
    width: 95% !important;
    max-width: 95% !important;
    margin: 10px auto !important;
  }
  
  .dialogClearsNew .el-dialog__body,
  .dialogViewGenerated .el-dialog__body {
    padding: 10px !important;
    max-height: 80vh;
    overflow-y: auto;
  }
  
  .certificate-wrapper {
    min-height: 400px;
  }
  
  .certificate-content {
    padding: 4% 6% 18% 8%;
  }
  
  .certificate-title {
    font-size: 25px;
    margin-bottom: 0px;
  }
  
  .certificate-body {
    font-size: 15px;
    line-height: 1.8;
  }
  
  .certificate-paragraph {
    margin-bottom: 10px;
  }
  
  .certificate-signature {
    margin-top: 0px;
    padding-right: 0%;
  }
  
  .signature-company {
    font-size: 16px;
  }
  
  .signature-date {
    font-size: 14px;
  }
  
  /* 移动端印章大小调整 */
  .signature-seal {
    width: 80px;
    height: 80px;
    right: 3%;
    opacity: 0.9;
  }
  
  /* 移动端生成的图片调整 */
  .generated-image-overlay {
    min-height: 400px;
    padding-top: 10px;
    justify-content: flex-start;
  }
  
  .generated-image {
    width: 95% !important;
    max-height: calc(100% - 150px) !important;
  }
  
  .image-tips {
    font-size: 12px;
    padding: 5px 0;
    color: #F56C6C !important; /* 移动端也保持红色 */
    margin-top: 5px;
    margin-bottom: 5px;
  }
  
  .clarity-prompt {
    padding: 5px 15px;
  }
  
  .clarity-text {
    font-size: 12px;
    margin-bottom: 10px;
  }
  
  .copy-btn-container {
    width: 100%;
  }
  
  .copy-btn {
    width: 100%;
    max-width: 200px;
  }
  
  /* 移动端合同明细按钮 */
  .contract-detail-btn {
    width: 100%;
    max-width: 200px;
  }
  
  .paymentDetail_box_con h2 .clear-certificate {
    font-weight: bold !important;
    color: rgb(207, 68, 26) !important;
    font-size: 19px;
    cursor: pointer;
    padding: 0 10px;
  }
  
  /* 移动端查看证明调整 */
  .view-generated-container {
    min-height: 300px;
    padding: 10px;
    justify-content: flex-start;
  }
  
  .view-generated-image {
    max-height: 200px;
    width: 95%;
  }
  
  .view-generated-tips {
    font-size: 12px;
    margin-top: 10px;
    padding: 8px 0;
    color: #F56C6C !important; /* 移动端也保持红色 */
  }
  
  /* 移动端按钮调整 */
  .dialog-footer {
    flex-direction: row;
    flex-wrap: wrap;
    gap: 10px;
    padding: 10px;
  }
  
  .dialog-footer .el-button {
    width: auto;
    min-width: 100px;
    margin: 0;
  }
  
  /* 移动端浏览器提示弹窗调整 */
  .dialogBrowserPrompt.el-dialog {
    width: 90% !important;
    max-width: 90% !important;
    margin: 20px auto !important;
  }
  
  .dialogBrowserPrompt .el-dialog__body {
    padding: 15px !important;
  }
  
  .dialogBrowserPrompt .el-dialog__footer {
    padding: 10px 15px 15px !important;
  }
}

/* 平板适配 */
@media screen and (min-width: 481px) and (max-width: 1768px) {
  .dialogClearsNew.el-dialog,
  .dialogViewGenerated.el-dialog {
    width: 95% !important;
    max-width: 95% !important;
    margin: 10px auto !important;
  }
  
  .dialogClearsNew .el-dialog__body,
  .dialogViewGenerated .el-dialog__body {
    padding: 10px !important;
    max-height: 80vh;
    overflow-y: auto;
  }
  
  .certificate-wrapper {
    min-height: 400px;
  }
  
  .certificate-content {
    padding: 4% 6% 18% 8%;
  }
  
  .certificate-title {
    font-size: 55px;
    margin-bottom: 5px;
  }
  
  .certificate-body {
    font-size: 25px;
    line-height: 1.8;
  }
  
  .certificate-paragraph {
    margin-bottom: 10px;
  }
  
  .certificate-signature {
    margin-top: 0px;
    padding-right: 0%;
  }
  
  .signature-company {
    font-size: 26px;
  }
  
  .signature-date {
    font-size: 24px;
  }
  
  /* 移动端印章大小调整 */
  .signature-seal {
    width: 120px;
    height: 120px;
    right: 3%;
    opacity: 0.9;
  }
  
  /* 移动端生成的图片调整 */
  .generated-image-overlay {
    min-height: 400px;
    padding-top: 10px;
    justify-content: flex-start;
  }
  
  .generated-image {
    width: 95% !important;
    max-height: calc(100% - 150px) !important;
  }
  
  .image-tips {
    font-size: 12px;
    padding: 5px 0;
    color: #F56C6C !important; /* 移动端也保持红色 */
    margin-top: 5px;
    margin-bottom: 5px;
  }
  
  .clarity-prompt {
    padding: 5px 15px;
  }
  
  .clarity-text {
    font-size: 12px;
    margin-bottom: 10px;
  }
  
  .copy-btn-container {
    width: 100%;
  }
  
  .copy-btn {
    width: 100%;
    max-width: 200px;
  }
  
  /* 平板合同明细按钮 */
  .contract-detail-btn {
    width: 100%;
    max-width: 200px;
  }
  
  .paymentDetail_box_con h2 .clear-certificate {
    font-weight: bold !important;
    color: rgb(207, 68, 26) !important;
    font-size: 19px;
    cursor: pointer;
    padding: 0 10px;
  }
  
  /* 移动端查看证明调整 */
  .view-generated-container {
    min-height: 300px;
    padding: 10px;
    justify-content: flex-start;
  }
  
  .view-generated-image {
    max-height: 200px;
    width: 95%;
  }
  
  .view-generated-tips {
    font-size: 12px;
    margin-top: 10px;
    padding: 8px 0;
    color: #F56C6C !important; /* 移动端也保持红色 */
  }
  
  /* 移动端按钮调整 */
  .dialog-footer {
    flex-direction: row;
    flex-wrap: wrap;
    gap: 10px;
    padding: 10px;
  }
  
  .dialog-footer .el-button {
    width: auto;
    min-width: 100px;
    margin: 0;
  }
  
  /* 移动端浏览器提示弹窗调整 */
  .dialogBrowserPrompt.el-dialog {
    width: 90% !important;
    max-width: 90% !important;
    margin: 20px auto !important;
  }
  
  .dialogBrowserPrompt .el-dialog__body {
    padding: 15px !important;
  }
  
  .dialogBrowserPrompt .el-dialog__footer {
    padding: 10px 15px 15px !important;
  }
}

/* 华为折叠屏特殊适配 (如 Mate X5, Mate X6) */
@media screen and (min-width: 481px) and (max-width: 800px) and (max-height: 900px) {
  .certificate-title {
    font-size: 30px !important;
    margin-bottom: 5px !important;
  }
  
  .certificate-body {
    font-size: 20px !important;
    line-height: 1.8 !important;
  }
  
  /* 可选：进一步调整其他元素以适应小折叠屏 */
  .certificate-content {
    padding: 3% 5% 15% 6% !important;
  }
  
  .signature-company {
    font-size: 22px !important;
  }
  
  .signature-date {
    font-size: 20px !important;
  }
  
  .signature-seal {
    width: 100px !important;
    height: 100px !important;
  }
}

</style>


// WEBPACK FOOTER //
// src/components/page/paymentDetail.vue